import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { LegalLayout, LegalSection } from '../components/LegalLayout';

export default function Privacy() {
  return (
    <LegalLayout
      testid="privacy-page"
      eyebrow="Privacy Policy"
      icon={ShieldCheck}
      title="Privacy Policy"
      intro="This policy explains how Lunar Legacies handles information collected through LunarLegacies.com."
      seo={{
        path: '/privacy',
        title: 'Privacy Policy | Lunar Legacies',
        description: 'How Lunar Legacies handles personal information collected through LunarLegacies.com contact forms and the Collector List email signup.',
      }}
    >
      <LegalSection heading="Information We Collect" testid="privacy-collect">
        <p>We only collect what you choose to give us through our forms:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><span className="text-white/90">Contact form</span> — your name, email, and message.</li>
          <li><span className="text-white/90">Collector List / email signup</span> — your email address (and name, if provided).</li>
          <li><span className="text-white/90">Consignment inquiries</span> — your name, email, phone (optional), item description, and any photos you upload.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="How We Use It" testid="privacy-use">
        <p>
          We use this information solely to respond to your inquiry, evaluate potential consignments, and send auction
          announcements to those who join our Collector List. We do not sell or rent your personal information.
        </p>
      </LegalSection>

      <LegalSection heading="Email Announcements" testid="privacy-email">
        <p>
          If you join the Collector List, you can ask to be removed at any time by emailing{' '}
          <a href="mailto:lunarlegacies@gmail.com" className="text-luxury-goldLight hover:text-luxury-gold transition-colors">lunarlegacies@gmail.com</a>.
        </p>
      </LegalSection>

      <LegalSection heading="Cookies & Analytics" testid="privacy-cookies">
        <p>
          LunarLegacies.com does not use advertising trackers or third-party analytics. The site uses your browser's local
          storage only to keep site administrators signed in — it is not used to track visitors.
        </p>
      </LegalSection>

      <LegalSection heading="Data Handling" testid="privacy-data">
        <p>
          Inquiries and signups are stored securely and are accessible only to Lunar Legacies. Form submissions are also
          emailed to us so we can respond.
        </p>
      </LegalSection>

      <LegalSection heading="Contact" testid="privacy-contact">
        <p>
          Questions about your information? Email{' '}
          <a href="mailto:lunarlegacies@gmail.com" className="text-luxury-goldLight hover:text-luxury-gold transition-colors">lunarlegacies@gmail.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
